import { exerciseAssetsClient } from "../api/ApiClients";
import {
  ApproveSuggestedExerciseAssetCommand,
  ArchiveExerciseAssetCommand,
  BodypartType,
  CreateExerciseAssetCommand,
  ExerciseAssetSort,
  ExerciseAssetStatus,
  ExerciseAssetType,
  IApproveSuggestedExerciseAssetCommand,
  IArchiveExerciseAssetCommand,
  ICreateExerciseAssetCommand,
  IRestoreExerciseAssetCommand,
  ISuggestExerciseAssetCommand,
  IToggleTeamExerciseVisibilityCommand,
  IUpdateExerciseAssetCommand,
  MovementPatternType,
  PaginatedListOfExerciseAssetDto,
  RestoreExerciseAssetCommand,
  SuggestExerciseAssetCommand,
  ToggleTeamExerciseVisibilityCommand,
  UpdateExerciseAssetCommand,
} from "@growth-machine-llc/stridist-api-client";
import ServiceBase from "./ServiceBase";

class ExerciseAssetService extends ServiceBase {
  getExerciseAssets(
    pageNumber: number,
    pageSize: number,
    searchQuery: string = null,
    status: ExerciseAssetStatus = null,
    bodypart: BodypartType[] = null,
    movementPattern: MovementPatternType[] = null,
    orderBy: ExerciseAssetSort = ExerciseAssetSort.NAME_ASC,
    type: ExerciseAssetType = ExerciseAssetType.PRIVATE,
    tagsIds: number[] = null,
    exactMatch: boolean = false,
    exerciseId: number = null,
  ): Promise<PaginatedListOfExerciseAssetDto> {
    return exerciseAssetsClient.getExerciseAssets(
      pageNumber,
      pageSize,
      searchQuery,
      orderBy,
      bodypart,
      movementPattern,
      status,
      type,
      tagsIds,
      exactMatch,
      exerciseId,
    );
  }

  createExerciseAsset(variables: ICreateExerciseAssetCommand) {
    const command = new CreateExerciseAssetCommand(variables);
    return exerciseAssetsClient.createExerciseAsset(command);
  }

  updateExerciseAsset(variables: IUpdateExerciseAssetCommand) {
    const command = new UpdateExerciseAssetCommand(variables);
    return exerciseAssetsClient.updateExerciseAsset(command.id, command);
  }

  archiveExerciseAsset(variables: IArchiveExerciseAssetCommand) {
    const command = new ArchiveExerciseAssetCommand(variables);
    return exerciseAssetsClient.archiveExerciseAsset(command);
  }

  restoreExerciseAsset(variables: IRestoreExerciseAssetCommand) {
    const command = new RestoreExerciseAssetCommand(variables);
    return exerciseAssetsClient.restoreExerciseAsset(command);
  }

  deleteExerciseAsset(id: number) {
    return exerciseAssetsClient.deleteExerciseAsset(id);
  }

  async getExerciseAssetsCount() {
    return exerciseAssetsClient.getExerciseAssetsCount();
  }

  async suggestExerciseAsset(variables: ISuggestExerciseAssetCommand) {
    const command = new SuggestExerciseAssetCommand(variables);
    return exerciseAssetsClient.suggestExerciseAsset(command);
  }

  async approvePendingExerciseAsset(
    variables: IApproveSuggestedExerciseAssetCommand,
  ) {
    const command = new ApproveSuggestedExerciseAssetCommand(variables);
    return exerciseAssetsClient.approveSuggestedExerciseAsset(command);
  }

  async toggleTeamExerciseVisibility(
    variables: IToggleTeamExerciseVisibilityCommand,
  ): Promise<void> {
    const command = new ToggleTeamExerciseVisibilityCommand(variables);
    return exerciseAssetsClient.toggleTeamExerciseVisibility(command);
  }
}

export default new ExerciseAssetService();
